import { useTranslation } from "react-i18next";
import { TMeetingInfo } from "../../../../../../../services/api/instances/meetingsApi/types";
import { AppDatePicker } from "../../../../../../../shared/components/AppDatePicker";
import { AppInput } from "../../../../../../../shared/components/AppInput";
import {
  ChangeHandlerValue,
  TTranscriptionInfoInputs,
} from "../../../../../types";
import styles from "./styles.module.css";

interface Props {
  info: TMeetingInfo;
  handleChangeInfo: (
    value: ChangeHandlerValue,
    type: TTranscriptionInfoInputs
  ) => void;
  isDisabled?: boolean;
  className?: string;
}

export const TranscriptInfoBlock = ({
  info,
  isDisabled,
  handleChangeInfo,
  className,
}: Props) => {
  const { t } = useTranslation();

  const date = info?.meeting_date
    ? new Date(info?.meeting_date as string)
    : null;

  return (
    <div className={styles["info-container"]}>
      <div className={styles["flex-container"]}>
        <AppInput
          value={info?.meeting_name ?? ""}
          onChange={(e) => handleChangeInfo(e.target.value, "title")}
          placeholder={t("meetings.input_name_placeholder")}
          disabled={isDisabled}
          className={styles["meeting-title-input"]}
        />
        <AppDatePicker
          value={date}
          onChange={(v) => handleChangeInfo(v, "date")}
          disabled={isDisabled}
          className={styles["meeting-date-input"]}
        />
      </div>
      <AppInput
        value={info?.meeting_description ?? ""}
        onChange={(e) => handleChangeInfo(e.target.value, "description")}
        placeholder={t("meetings.input_description_placeholder")}
        rows={5}
        multiline
        disabled={isDisabled}
        className={styles["description-input"]}
      />
    </div>
  );
};
